import * as React from 'react'
import { theme } from '../../theme'

interface Props {
	show: boolean
	message?: string
}

export const LoadingOverlay = ({ show, message }: Props) => {
	if (!show) return null

	return (
		<div
			style={{
				position: 'absolute',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: 'rgba(0, 0, 0, 0.7)',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				flexDirection: 'column',
				gap: theme.spacing.sm,
				color: 'white',
				zIndex: 100,
			}}
		>
			<div
				style={{
					width: '40px',
					height: '40px',
					border: '3px solid rgba(255, 255, 255, 0.3)',
					borderTop: '3px solid white',
					borderRadius: '50%',
					animation: 'spin 1s linear infinite',
				}}
			/>
			{message && <div style={{ fontSize: '14px', fontWeight: 500 }}>{message}</div>}
		</div>
	)
}
